import React, { useState } from "react";

export default function TimePicker({ onTimeChange, showNow }) {
    const [hour, setHour] = useState("");
    const [minute, setMinute] = useState("");
    const [minutes, setMinutes] = useState(
        Array.from({ length: 12 }, (_, i) => i * 5)
    ); // Initialize with multiples of 5

    const handleHourChange = (event) => {
        const newHour = event.target.value;
        setHour(newHour);
        onTimeChange(newHour, minute);
    };

    const handleMinuteChange = (event) => {
        const newMinute = event.target.value;
        setMinute(newMinute);
        onTimeChange(hour, newMinute);
    };

    const setNowTime = () => {
        const now = new Date();
        const currentHour = now.getHours();
        const currentMinute = now.getMinutes();
        if (!minutes.includes(currentMinute)) {
            // Check if the current minute is already in the array
            const newMinutes = [...minutes, currentMinute].sort((a, b) => a - b); // Sort minutes after adding
            setMinutes(newMinutes); // Update state
        }
        setHour(currentHour.toString());
        setMinute(currentMinute.toString());
        onTimeChange(currentHour.toString(), currentMinute.toString());
    };

    return (
        <>
            <div className="flex gap-2 sm:gap-4 items-end flex-wrap">
                <div>
                    <label htmlFor="hour" id="hourLabel" className="text-sm">
                        Heure
                    </label>
                    <select
                        id="hour"
                        className="input select !w-20 sm:!w-24 !font-mono"
                        onChange={handleHourChange}
                        value={hour}
                        aria-labelledby="hourLabel"
                        aria-required="true"
                        aria-invalid={hour === "" ? "true" : "false"}
                    >
                        <option value="">--</option>
                        {Array.from({ length: 24 }, (_, i) => (
                            <option key={i} value={i.toString()}>
                                {i}
                            </option>
                        ))}
                    </select>
                </div>
                <div>
                    <label htmlFor="minute" id="minuteLabel" className="text-sm">
                        Minutes
                    </label>
                    <select
                        id="minute"
                        className="input select !w-20 sm:!w-24 !font-mono"
                        onChange={handleMinuteChange}
                        value={minute}
                        aria-labelledby="minuteLabel"
                        aria-required="true"
                        aria-invalid={minute === "" ? "true" : "false"}
                    >
                        <option value="">--</option>
                        {minutes.map((min) => (
                            <option key={min} value={min.toString()}>
                                {String(min).padStart(2, "0")}
                            </option>
                        ))}
                    </select>
                </div>


            </div>
        </>
    );
}